/**
 * Sidebar nav configuration - single source of truth.
 * All sidebar items, categories, roles and feature-flag gating live here.
 */

import React from 'react';
import {
  HomeOutlined,
  LanguageOutlined,
  CloudCircleOutlined,
  DonutSmallOutlined,
  PlaylistAddCheckCircleOutlined,
  PeopleOutlined,
  MonitorHeartOutlined,
  BuildCircleOutlined,
} from '@mui/icons-material';
import { SHOW_BUGNION, SHOW_SERVICES_MONITOR, SHOW_SMSC_CLIENT_CONFIG } from '../../config';

export interface NavItem {
  id: string;
  label: string;
  description?: string;
  to: string;
  icon: React.ReactElement;
  /** Single role OR array of roles (any match = visible) */
  roles: string[];
  /** Feature-flag gate - item hidden when false */
  show?: boolean;
  badge?: string | number;
}

export interface NavCategory {
  id: string;
  label: string;
  items: NavItem[];
}

export const navConfig: NavCategory[] = [
  {
    id: 'home',
    label: 'Home',
    items: [
      {
        id: 'overview',
        label: 'Overview',
        description: 'Dashboard home',
        to: '/',
        icon: <HomeOutlined />,
        roles: ['*'],
      },
    ],
  },
  {
    id: 'integration',
    label: 'Integration',
    items: [
      {
        id: 'ihub',
        label: 'iHub Adapter',
        description: 'Customer migration & integration',
        to: '/ihub_adapter',
        icon: <CloudCircleOutlined />,
        roles: ['IHUB_CUSTOMER_MIGRATION'],
      },
    ],
  },
  {
    id: 'operations',
    label: 'Operations',
    items: [
      {
        id: 'scraper',
        label: 'Web Scraper',
        description: 'Patent & data scrapers',
        to: '/component_webscraper',
        icon: <LanguageOutlined />,
        roles: ['WEB_SCRAPER'],
      },
      {
        id: 'batchid',
        label: 'Batch ID',
        description: 'Generate batch payment identifiers',
        to: '/batchid',
        icon: <DonutSmallOutlined />,
        roles: ['AMS_PAYMENTS', 'PRS_PAYMENTS', 'TM1_PAYMENTS'],
      },
      {
        id: 'bugnion',
        label: 'Bugnion',
        description: 'Interface management and monitoring',
        to: '/bugnion',
        icon: <PlaylistAddCheckCircleOutlined />,
        roles: ['BUGNION_INTERFACE'],
        show: SHOW_BUGNION,
      },
    ],
  },
  {
    id: 'admin',
    label: 'Admin',
    items: [
      {
        id: 'users',
        label: 'User Management',
        description: 'Manage users, roles and permissions',
        to: '/user_management',
        icon: <PeopleOutlined />,
        roles: ['USER_MANAGEMENT'],
      },
      {
        id: 'services-monitor',
        label: 'Services Monitor',
        description: 'Service health and availability',
        to: '/services_monitor',
        icon: <MonitorHeartOutlined />,
        roles: ['ROLE_SERVICES_MONITOR'],
        show: SHOW_SERVICES_MONITOR,
      },
      {
        id: 'smsc',
        label: 'SMSC Config',
        description: 'Smart Scanning Proxy onboarding',
        to: '/twindolphin_onboarding',
        icon: <BuildCircleOutlined />,
        roles: ['ROLE_SMSC_ADMIN'],
        show: SHOW_SMSC_CLIENT_CONFIG,
      },
    ],
  },
];
